import moment from 'moment';
import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import { constants } from '@nhl/formatter-utilities';

import actionTypes from './actionTypes';

/* State shape
{
    loadingState: {
        isLoading: bool,
        success: bool,
        error: Array
    },
    newsState: {
        newsItems: Array,
        start: int,
        limit: int,
        fromDate: moment
        total: int
    }
}
*/

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_NEWS)(actionTypes.NEWS_RESPONSE);

const startReducer = (state = 0, action) => {
    const { payload } = action;

    if (action.type === actionTypes.REQUEST_NEWS) {
        return payload.start;
    } else if (action.type === actionTypes.NEWS_RESPONSE) {
        return state + payload.newsItems.length;
    }

    return state;
};

const limitReducer = (state = 0, action) => {
    const { payload } = action;

    if (action.type === actionTypes.REQUEST_NEWS) {
        return payload.limit;
    }

    return state;
};

const fromDateReducer = (state = null, action) => {
    const { payload } = action;

    if (action.type === actionTypes.REQUEST_NEWS) {
        return payload.fromDate || null;
    }

    return state;
};

const newsItemsReducer = (state = [], action) => {
    const { payload } = action;

    if (action.type === actionTypes.NEWS_RESPONSE) {
        return [...payload.newsItems, ...state].filter((item, idx, self) =>
            self.findIndex(i => i.id === item.id) === idx
        ).sort((a, b) => {
            const dateDiff = moment(a.publishDate, constants.LINK_REST_DATE_FORMAT).diff(moment(b.publishDate, constants.LINK_REST_DATE_FORMAT));

            return dateDiff === 0 ? a.id - b.id : dateDiff;
        }).reverse();
    } else if (action.type === actionTypes.CLEAR_CACHE) {
        return [];
    }

    return state;
};

const totalReducer = (state = 0, action) => {
    const { payload } = action;

    if (action.type === actionTypes.NEWS_RESPONSE) {
        return payload.total;
    }

    return state;
};

const newsStateReducer = combineReducers({
    newsItems: newsItemsReducer,
    start: startReducer,
    limit: limitReducer,
    fromDate: fromDateReducer,
    total: totalReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    newsState: newsStateReducer
});

export default reducer;